import React, {useEffect, useState} from 'react';
import {useDispatch, useSelector} from 'react-redux';
import {useNavigate, useParams} from 'react-router-dom';
import {
  getCustomersByEntrance,
  getEntranceDetails,
  openModal,
} from '../actions';
import {
  CustomersTab,
  Layout,
  PageHeader,
  Spinner,
  TabsContainer,
} from '../components';

const HEADERS = ['Customers'];

const EntranceDetails = () => {
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const {id} = useParams();
  const [loading, setLoading] = useState(true);
  const {entranceById} = useSelector(s => s.entrances);
  const CustomersTable = <CustomersTab entrance />;

  const TAB_CONTENTS = [CustomersTable];

  const onBack = () => {
    navigate(-1);
  };

  const onEdit = () => {
    dispatch(
      openModal('EditEntranceModal', {
        buildingId: entranceById.buildingId,
        entrance: entranceById,
      }),
    );
  };
  const onDelete = () => {
    dispatch(openModal('DeleteModal', {type: 'entrance', item: entranceById}));
  };

  useEffect(() => {
    if (loading && entranceById && entranceById.id.toString() === id) {
      setLoading(false);
    }
  }, [entranceById]);

  useEffect(() => {
    dispatch(getEntranceDetails(id));
    dispatch(getCustomersByEntrance(id));
  }, []);

  if (loading) {
    return (
      <Layout>
        <Spinner />
      </Layout>
    );
  }

  return (
    <Layout>
      <PageHeader
        onBack={onBack}
        onEdit={onEdit}
        onDelete={
          !!entranceById
            ? () => {
                onDelete();
              }
            : null
        }
        title={entranceById?.name}
      />
      {!!entranceById && (
        <TabsContainer tabHeaders={HEADERS} tabContents={TAB_CONTENTS} />
      )}
    </Layout>
  );
};

export default EntranceDetails;
